import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../../../shared/components/table/components/ReactTableCustomizer';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const TableRadioPharmacy = ({ title, reactTableData, ReactTableActions }) => {
    const { t } = useTranslation('common');

    const [rows, setData] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(true);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);

    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        setData(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setData(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };
    const history = useHistory();

    const tableConfig = {
        isEditable,
        isResizable,
        isEditable,
        isSortable,
        withDragAndDrop,
        withPagination,
        manualPageSize: [10, 20, 30, 40],
        useActions: true,
        actions: ReactTableActions
    };

    const columns = [
        {
            Header: "Nombre",
            accessor: 'nombre_paciente',
        },
        {
            Header: "Edad",
            accessor: 'edad',
        },
        {
            Header: "Identificación",
            accessor: 'num_documento',
        },
        {
            Header: "Estudio",
            accessor: 'estudio',
        },
        {
            Header: "Radio Farmaco",
            accessor: 'radiofarmaco',
        },
        {
            Header: "Hora Marcado",
            accessor: 'hora_marcado',
        },
        {
            Header: "Hora Admon",
            accessor: 'hora_admon',
        },
        
        /*
        {
            Header: "Via Admon",
            accessor: 'via_admon',
        },
        {
            Header: "Lote",
            accessor: 'lote',
        },
        {
            Header: "Conservar",
            accessor: 'conservar',
        },
        {
            Header: "Estabilidad",
            accessor: 'estabilidad',
        },
        {
            Header: "Actividad (MBQ)",
            accessor: 'actividad',
        },
        {
            Header: "Precal",
            accessor: 'precal',
        },
        {
            Header: "Firma Quien Prepara",
            accessor: 'firma',
        }
        */
        

        /*
        "id_tercero": 2,
        "id_ordenpro": null,
        "id_admision": 16,
        "id_cita": 80,
        "id_historia": 16
        */
    ]
    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columns}
                        data={rows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

TableRadioPharmacy.propTypes = {
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default TableRadioPharmacy;
